import Vue from "vue";
import VueRouter from "vue-router";
import NavFrame from "@/components/NavFrame.vue";
import form from "view-design/src/mixins/form";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "navFrame",
    component: NavFrame,
    redirect: "home",
    children: [
      //---------------------------查詢快件-------------------------------------
      {
        path: "/home", //查詢快件
        name: "home",
        component: () => import("../views/home/Home.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/homeDetail", //查詢快件->明細
        name: "homeDetail",
        component: () => import("../views/homeDetail/homeDetail.vue"),
      },
      {
        path: "/map", //查詢快件->明細
        name: "map",
        component: () => import("../views/maps/Map.vue"),
      },
      //---------------------------珠海倉庫-------------------------------------
      {
        path: "/scanIn", //珠海倉庫->掃描入庫
        name: "scanIn",
        // component: () => import("../views/depository/scanIn/ScanIn_new3.vue"),
        component: () => import("../views/depository/scanIn/ScanIn4.vue"),
        meta: {
          keepAlive: false,
        },
      },
      {
        path: "/scanInBig", //珠海倉庫->掃描入庫 转店
        name: "scanIn",
        component: () => import("../views/depository/scanIn/ScanIn5.vue"),
        meta: {
          keepAlive: false,
        },
      },
      {
        path: "/scanInMerchantBig", //珠海倉庫->掃描入庫
        name: "scanInMerchantBig",
        // component: () => import("../views/depository/scanIn/ScanIn_new3.vue"),
        component: () => import("../views/depository/scanIn/ScanIn11.vue"),
        meta: {
          keepAlive: false,
        },
      },
      {
        path: "/scanIn2", //珠海倉庫->掃描入庫 new
        name: "scanIn2",
        // component: () => import('../views/depository/scanIn2/ScanIn.vue'),
        // component: () => import('../views/depository/scanIn2/ScanIn2.vue'),
        // component: () => import("../views/depository/scanIn2/ScanIn3.vue"),
        component: () => import("../views/depository/scanIn2/ScanIn4.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/scanInMerchant", //珠海倉庫->掃描入庫 new 合作方  scanInMerchant
        name: "scanInMerchant",
        component: () => import("../views/depository/scanIn2/ScanIn10.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/scanInMore", //珠海倉庫->掃描入庫
        name: "scanInMore",
        component: () =>
          import("../views/depository/scanInMore/scanInMore2.vue"),
        // component: () => import('../views/depository/scanInMore/scanInMore_print.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/scanOut", //珠海倉庫->掃描出庫
        name: "scanOut",
        component: () => import("../views/depository/scanOut/ScanOut.vue"),
      },
      {
        path: "/deliverTodo", //珠海倉庫->待出庫
        name: "deliverTodo",
        component: () =>
          import("../views/depository/deliverTodo/DeliverTodo_new.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/bagNumberList", //珠海倉庫->袋号列表
        name: "bagNumberList",
        component: () =>
          import("../views/depository/bagNumberList/BagNumberList.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/pddList", //珠海倉庫->袋号列表
        name: "pddList",
        component: () => import("../views/depository/pddList/PddList.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/delivered", //珠海倉庫->已出庫
        name: "delivered",
        component: () =>
          import("../views/depository/delivered/Delivered_new.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/deliverExc", //珠海倉庫->異常件
        name: "deliverExc",
        component: () =>
          import("../views/depository/deliverExc/DeliverExc.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/deliverTodoEdit", //珠海倉庫->待出庫->修改信息
        name: "deliverTodoEdit",
        component: () =>
          import("../views/depository/deliverEdit/DeliverEdit3.vue"),
      },
      {
        path: "/deliveredEdit", //珠海倉庫->已出庫->修改信息
        name: "deliveredEdit",
        component: () =>
          import("../views/depository/deliverEdit/DeliverEdit.vue"),
      },
      {
        path: "/deliverExcEdit", //珠海倉庫->異常件->修改信息
        name: "deliverExcEdit",
        component: () =>
          import("../views/depository/deliverExcEdit/DeliverExcEdit.vue"),
      },
      {
        path: "/deliverClaim", //珠海倉庫->認領件
        name: "deliverClaim",
        component: () =>
          import("../views/depository/deliverClaim/DeliverClaim.vue"),
      },
      {
        path: "/logisticsInfo", //珠海倉庫->已出庫->物流信息
        name: "logisticsInfo",
        component: () =>
          import("../views/depository/logisticsInfo/LogisticsInfo.vue"),
      },
      {
        path: "/ExclogisticsInfo", //珠海倉庫->異常件->物流信息
        name: "ExclogisticsInfo",
        component: () =>
          import("../views/depository/ExclogisticsInfo/ExcLogisticsInfo.vue"),
      },
      //---------------------------澳門倉庫-------------------------------------
      {
        path: "/macaoScanIn", //澳門倉庫->掃描入庫
        name: "macaoScanIn",
        component: () => import("../views/macaoDepository/scanIn/ScanIn.vue"),
      },
      {
        path: "/macaoScanOut", //澳門倉庫->掃描出庫
        name: "macaoScanOut",
        component: () => import("../views/macaoDepository/scanOut/ScanOut.vue"),
      },
      {
        path: "/macaoScanInList", //澳門倉庫->已入庫
        name: "macaoScanInList",
        component: () =>
          import("../views/macaoDepository/scanInList/ScanInList.vue"),
      },
      {
        path: "/macaoScanOutList", //澳門倉庫->已出庫
        name: "macaoScanOutList",
        component: () =>
          import("../views/macaoDepository/scanOutList/ScanOutList.vue"),
      },
      {
        path: "/abnormalList", //澳門倉庫->超期回倉件列表
        name: "abnormalList",
        component: () =>
          import("../views/macaoDepository/abnormalList/abnormalList.vue"),
      },
      {
        path: "/overtimeTaking", //澳門倉庫->超時件攬收
        name: "overtimeTaking",
        component: () =>
          import("../views/macaoDepository/overtimeTaking/overtimeTaking.vue"),
      },
      {
        path: "/overtimeWarehouse", //澳門倉庫->超時快件回倉
        name: "overtimeWarehouse",
        component: () =>
          import(
            "../views/macaoDepository/overtimeWarehouse/overtimeWarehouse.vue"
          ),
      },
      {
        path: "/overtimeCancel", //澳門倉庫->超時快件核銷
        name: "overtimeCancel",
        component: () =>
          import("../views/macaoDepository/overtimeCancel/overtimeCancel.vue"),
      },
      {
        path: "/transferList", //澳門倉庫->轉店列表
        name: "transferList",
        component: () =>
          import("../views/macaoDepository/transferList/transferList.vue"),
      },
      //---------------------------澳門門店-------------------------------------
      {
        path: "/shopOnShelves", //澳門門店->門店上架
        name: "shopOnShelves",
        component: () =>
          import("../views/macaoShop/shopOnShelves/ShopOnShelves.vue"),
      },
      {
        path: "/shopManage", //澳門門店->門店管理
        name: "shopManage",
        component: () => import("../views/macaoShop/shopManage/ShopManage.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/shopManageAdd", //澳門門店->門店管理->新增門店
        name: "shopManageAdd",
        component: () =>
          import("../views/macaoShop/shopManageAdd/ShopManageAdd.vue"),
      },
      {
        path: "/shopManageEdit", //澳門門店->門店管理->修改門店
        name: "shopManageEdit",
        component: () =>
          import("../views/macaoShop/shopManageEdit/ShopManageEdit.vue"),
      },
      {
        path: "/shopUserIntegral", //澳門門店->門店管理->積分操作
        name: "shopUserIntegral",
        component: () =>
          import("../views/macaoShop/shopUserIntegral/shopUserIntegral.vue"),
      },
      {
        path: "/scanSign", //澳門門店->簽收掃描
        name: "scanSign",
        component: () => import("../views/macaoShop/scanSign/ScanSign.vue"),
      },
      {
        path: "/scanSpecial", //澳門門店->特殊掃描
        name: "scanSpecial",
        component: () =>
          import("../views/macaoShop/scanSpecial/ScanSpecial.vue"),
      },
      {
        path: "/signTodo", //澳門門店->未簽收
        name: "signTodo",
        component: () => import("../views/macaoShop/signTodo/SignTodo.vue"),
        // component: () => import('../views/macaoShop/signTodo/SignTodo_new.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/signTodoNew2", //澳門門店->未簽收  new 2
        name: "signTodoNew2",
        // component: () => import('../views/macaoShop/signTodo/SignTodo_new2.vue'),
        component: () =>
          import("../views/macaoShop/signTodo/SignTodo_new3.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/signTodoCount", //澳門門店->未簽收统计
        name: "signTodoCount",
        component: () =>
          import("../views/macaoShop/signTodo/SignTodoCount.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/shopSigntodologisticsInfo", //澳門門店->未簽收->物流信息
        name: "shopSigntodologisticsInfo",
        component: () =>
          import(
            "../views/macaoShop/shopSigntodologisticsInfo/shopSigntodologisticsInfo.vue"
          ),
      },
      {
        path: "/signed", //澳門門店->已簽收
        name: "signed",
        component: () => import("../views/macaoShop/signed/Signed.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/shopSignedlogisticsInfo", //澳門門店->已簽收->物流信息
        name: "shopSignedlogisticsInfo",
        component: () =>
          import(
            "../views/macaoShop/shopSignedlogisticsInfo/shopSignedlogisticsInfo.vue"
          ),
      },
      {
        path: "/shopSignetodoRemark", //澳門門店->未簽收->備註
        name: "shopSignetodoRemark",
        component: () =>
          import(
            "../views/macaoShop/shopSignetodoRemark/shopSignetodoRemark.vue"
          ),
      },
      {
        path: "/shopSignedRemark", //澳門門店->已簽收->備註
        name: "shopSignedRemark",
        component: () =>
          import("../views/macaoShop/shopSignedRemark/shopSignedRemark.vue"),
      },
      // {
      //     path: '/jybPayOutEdit', //澳門門店->賠付
      //     name: 'jybPayOutEdit',
      //     component: () => import('../views/macaoShop/jybPayOutEdit/JybPayOutEdit.vue')
      // },
      {
        path: "/stockscanIn", //澳門門店->記錄掃描
        name: "stockscanIn",
        component: () =>
          import("../views/macaoShop/stockscanIn/stockscanIn.vue"),
      },
      {
        path: "/stockscanInList", //澳門門店->記錄掃描列表
        name: "stockscanInList",
        component: () =>
          import("../views/macaoShop/stockscanInList/stockscanInList.vue"),
      },
      {
        path: "/overtimeList", //澳門門店->超期件列表
        name: "overtimeList",
        component: () =>
          import("../views/macaoShop/overtimeList/overtimeList.vue"),
      },
      {
        path: "/transferConfirm", //澳門倉庫->轉入本店確認
        name: "transferConfirm",
        component: () =>
          import("../views/macaoShop/transferConfirm/transferConfirm.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/transferWaiting", //澳門倉庫->待轉店列表
        name: "transferWaiting",
        component: () =>
          import("../views/macaoShop/transferWaiting/transferWaiting.vue"),
      },
      //---------------------------報表統計-------------------------------------
      {
        path: "/financeDetail", //報表統計->財務明細
        name: "financeDetail",
        component: () =>
          import("../views/reportStatistics/financeDetail/FinanceDetail.vue"),
      },
      {
        path: "/saleDetail", //報表統計->銷售明細
        name: "saleDetail",
        component: () =>
          import("../views/reportStatistics/saleDetail/SaleDetail.vue"),
      },
      {
        path: "/deliverDetail", //報表統計->銷售明細
        name: "deliverDetail",
        component: () =>
          import("../views/reportStatistics/deliverDetail/DeliverDetail.vue"),
      },
      {
        path: "/traffic", //報表統計->統計圖表
        name: "traffic",
        component: () =>
          import("../views/reportStatistics/traffic/traffic.vue"),
      },
      {
        path: "/dailyCount", //報表統計->每日快遞統計(全局)
        name: "dailyCount",
        component: () => import("../views/macaoShop/dailyCount/dailyCount.vue"),
      },
      {
        path: "/dailyCount2", //報表統計->每日快遞統計(全局)
        name: "dailyCount2",
        component: () =>
          import("../views/macaoShop/dailyCount/dailyCount2.vue"),
      },
      {
        path: "/dailyCountStore", //報表統計->每日快遞統計(門店)
        name: "dailyCountStore",
        component: () =>
          import("../views/macaoShop/dailyCountStore/dailyCountStore.vue"),
      },
      {
        path: "/customsDoc", //報表統計->報關資料
        name: "customsDoc",
        component: () =>
          import("../views/reportStatistics/customsDoc/CustomsDoc.vue"),
      },
      // {
      //     path: '/jybPayOut', //報表統計->集運幫賠付
      //     name: 'jybPayOut',
      //     component: () => import('../views/reportStatistics/jybPayOut/JybPayOut.vue')
      // },
      {
        path: "/payInfo", //報表統計->支付明細
        name: "payInfo",
        component: () =>
          import("../views/reportStatistics/payInfo/payInfo.vue"),
      },
      {
        path: "/notOnshelf", //報表統計->未上架報表
        name: "notOnshelf",
        component: () =>
          import("../views/reportStatistics/notOnshelf/notOnshelf.vue"),
      },
      {
        path: "/notOnshelf2", //報表統計->未上架報表
        name: "notOnshelf2",
        component: () =>
          import("../views/reportStatistics/notOnshelf/notOnshelf2.vue"),
      },
      {
        path: "/notOnshelfCount", //報表統計->未上架報表
        name: "notOnshelfCount",
        component: () =>
          import("../views/reportStatistics/notOnshelf/notOnshelfCount.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/abnormalCount", //報表統計->門店異常錄入報表
        name: "abnormalCount",
        component: () =>
          import("../views/reportStatistics/abnormalCount/abnormalCount.vue"),
      },
      {
        path: "/forecast", //報表統計->預報報表
        name: "forecast",
        component: () =>
          import("../views/reportStatistics/forecast/forecast.vue"),
      },
      {
        path: "/instorelist", //報表統計->已入庫報表
        name: "instorelist",
        component: () =>
          import("../views/reportStatistics/instorelist/instorelist.vue"),
      },
      {
        path: "/returnedItems", //報表統計->本地退
        name: "returnedItems",
        component: () =>
          import("../views/reportStatistics/returnedItems/returnedItems.vue"),
      },
      {
        path: "/kpiPackages", //報表統計->kpi
        name: "kpiPackages",
        component: () =>
          import("../views/reportStatistics/kpiPackages/kpiPackages.vue"),
      },
      //--------------------------積分管理-------------------------------------
      {
        path: "/integralLog", //積分管理->積分日誌
        name: "integralLog",
        component: () =>
          import("../views/integralManage/integralLog/IntegralLog.vue"),
      },
      {
        path: "/IntegralNewLog", //積分管理->積分日誌(新)
        name: "IntegralNewLog",
        component: () =>
          import("../views/integralManage/integralNewLog/IntegralNewLog.vue"),
      },
      {
        path: "/credit", //積分管理->線上充值積分
        name: "credit",
        component: () => import("../views/setting/credit/Credit.vue"),
      },
      {
        path: "/creditEdit", //積分管理->線上充值積分->增加/修改
        name: "creditEdit",
        component: () => import("../views/setting/creditEdit/CreditEdit.vue"),
      },
      {
        path: "/creditOffline", //積分管理->門店充值積分
        name: "creditOffline",
        component: () =>
          import("../views/setting/creditOffline/CreditOffline.vue"),
      },
      {
        path: "/creditEditOffline", //積分管理->門店充值積分->增加/修改
        name: "creditEditOffline",
        component: () =>
          import("../views/setting/creditEditOffline/CreditEditOffline.vue"),
      },
      {
        path: "/creditTypeSetting", //積分管理->贈送類型設置
        name: "creditTypeSetting",
        component: () =>
          import("../views/setting/creditTypeSetting/creditTypeSetting.vue"),
      },
      {
        path: "/creditTypeSettingEdit", //積分管理->贈送類型設置->修改
        name: "creditTypeSettingEdit",
        component: () =>
          import(
            "../views/setting/creditTypeSettingEdit/creditTypeSettingEdit.vue"
          ),
      },
      // {
      //     path: '/credit2', // 積分管理->活動積分
      //     name: 'credit2',
      //     component: () => import('../views/setting/credit2/Credit2.vue')
      // },
      // {
      //     path: '/credit2Edit', // 積分管理->活動積分->增加/修改
      //     name: 'credit2Edit',
      //     component: () => import('../views/setting/credit2Edit/Credit2Edit.vue')
      // },

      //--------------------------------會員管理------------------------------------
      {
        path: "/userList", //會員管理->會員列表
        name: "userList",
        component: () => import("../views/userManage/userList/UserList.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/addUser", //會員管理->新增会员
        name: "addUser",
        component: () => import("../views/userManage/userList/AddUser.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/userEdit", //會員管理->會員列表->修改資料
        name: "userEdit",
        component: () => import("../views/userManage/userEdit/UserEdit.vue"),
      },
      {
        path: "/userIntegral", //會員管理->會員列表->積分操作
        name: "userIntegral",
        component: () =>
          import("../views/userManage/userIntegral/UserIntegral.vue"),
      },
      {
        path: "/userStatistics", //會員管理->會員統計
        name: "userStatistics",
        component: () =>
          import("../views/userManage/userStatistics/UserStatistics.vue"),
      },

      //----------------------------權限管理-------------------------------------
      {
        path: "/adminList", //權限管理->管理員列表
        name: "adminList",
        component: () => import("../views/authManage/adminList/AdminList.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/adminAdd", //權限管理->管理員列表->增加資料
        name: "adminAdd",
        component: () => import("../views/authManage/adminAdd/AdminAdd.vue"),
      },
      {
        path: "/adminEdit", //權限管理->管理員列表->修改資料
        name: "adminEdit",
        component: () => import("../views/authManage/adminEdit/AdminEdit.vue"),
      },
      {
        path: "/adminRole", //權限管理->管理員列表->分派權限
        name: "adminRole",
        component: () => import("../views/authManage/adminRole/AdminRole.vue"),
      },
      {
        path: "/adminLog", //權限管理->管理員日誌
        name: "adminLog",
        component: () => import("../views/authManage/adminLog/AdminLog.vue"),
      },

      //----------------------------後臺設置-------------------------------------
      {
        path: "/bannerSetting", //後臺設置->Banner設置
        name: "bannerSetting",
        component: () =>
          import("../views/setting/bannerSetting/BannerSetting.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/bannerSettingAdd", //後臺設置->Banner設置->增加
        name: "bannerSettingAdd",
        component: () =>
          import("../views/setting/bannerSettingAdd/BannerSettingAdd.vue"),
      },
      {
        path: "/bannerSettingEdit", //後臺設置->Banner設置->增加
        name: "bannerSettingEdit",
        component: () =>
          import("../views/setting/bannerSettingEdit/BannerSettingEdit.vue"),
      },
      {
        path: "/setCustomDoc", //後臺設置->報關品名管理
        name: "setCustomDoc",
        component: () =>
          import("../views/setting/setCustomDoc/SetCustomDoc.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/setCustomDocEdit", //後臺設置->報關品名管理->修改資料
        name: "setCustomDocEdit",
        component: () =>
          import("../views/setting/setCustomDocEdit/SetCustomDocEdit.vue"),
      },
      {
        path: "/deliverHome", //後臺設置->送貨上門設定
        name: "deliverHome",
        component: () => import("../views/setting/deliverHome/DeliverHome.vue"),
      },
      {
        path: "/deliverHomeAdd", //後臺設置->送貨上門設定->增加
        name: "deliverHomeAdd",
        component: () =>
          import("../views/setting/deliverHomeAdd/DeliverHomeAdd.vue"),
      },
      {
        path: "/deliverHomeEdit", //後臺設置->送貨上門設定->修改
        name: "deliverHomeEdit",
        component: () =>
          import("../views/setting/deliverHomeEdit/DeliverHomeEdit.vue"),
      },
      {
        path: "/shelfManage", //後臺設置->貨架號管理
        name: "shelfManage",
        component: () => import("../views/setting/shelfManage/ShelfManage.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/shelfManageEdit", //後臺設置->貨架號管理->修改
        name: "shelfManageEdit",
        component: () =>
          import("../views/setting/shelfManageEdit/ShelfManageEdit.vue"),
      },
      {
        path: "/version", //後臺設置->版本更新
        name: "version",
        component: () => import("../views/setting/version/Version.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/versionEdit", //後臺設置->版本更新->增加/修改
        name: "versionEdit",
        component: () => import("../views/setting/versionEdit/VersionEdit.vue"),
      },
      {
        path: "/articleManage", //後臺管理->文章管理
        name: "articleManage",
        component: () =>
          import("../views/setting/articleManage/articleManage.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/articleManageEdit", //後臺管理->文章管理->修改
        name: "articleManageEdit",
        component: () =>
          import("../views/setting/articleManageEdit/articleManageEdit.vue"),
      },
      {
        path: "/articleManageAdd", //後臺管理->文章管理->增加
        name: "articleManageAdd",
        component: () =>
          import("../views/setting/articleManageAdd/articleManageAdd.vue"),
      },
      {
        path: "/appNotificationManage", //後臺管理->APP通知管理
        name: "appNotificationManage",
        component: () =>
          import(
            "../views/setting/appNotificationManage/appNotificationManage.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/appNotificationManageEdit", //後臺管理->APP通知管理->修改
        name: "appNotificationManageEdit",
        component: () =>
          import(
            "../views/setting/appNotificationManageEdit/appNotificationManageEdit.vue"
          ),
      },
      {
        path: "/appNotificationManageAdd", //後臺管理->APP通知管理->增加
        name: "appNotificationManageAdd",
        component: () =>
          import(
            "../views/setting/appNotificationManageAdd/appNotificationManageAdd.vue"
          ),
      },
      {
        path: "/advertiserManage", //後臺管理->廣告設置
        name: "advertiserManage",
        component: () =>
          import("../views/setting/advertiserManage/advertiserManage.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/advertiserManageEdit", //後臺管理->廣告設置->修改
        name: "advertiserManageEdit",
        component: () =>
          import(
            "../views/setting/advertiserManageEdit/advertiserManageEdit.vue"
          ),
      },
      {
        path: "/advertiserManageAdd", //後臺管理->廣告設置->增加
        name: "advertiserManageAdd",
        component: () =>
          import(
            "../views/setting/advertiserManageAdd/advertiserManageAdd.vue"
          ),
      },
      {
        path: "/complaintManage", //後臺管理->投訴類型設置
        name: "complaintManage",
        component: () =>
          import("../views/setting/complaintManage/complaintManage.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/complaintManageEdit", //後臺管理->投訴類型設置->修改
        name: "complaintManageEdit",
        component: () =>
          import(
            "../views/setting/complaintManageEdit/complaintManageEdit.vue"
          ),
      },
      {
        path: "/complaintManageAdd", //後臺管理->投訴類型設置->增加
        name: "complaintManageAdd",
        component: () =>
          import("../views/setting/complaintManageAdd/complaintManageAdd.vue"),
      },
      {
        path: "/recommendedManage", //後臺管理->推薦模塊
        name: "recommendedManage",
        component: () =>
          import(
            "../views/setting/recommended/recommendedManage/recommendedManage"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/recommendedEdit", //後臺管理->推薦模塊
        name: "recommendedEdit",
        component: () =>
          import(
            "../views/setting/recommended/recommendedEdit/recommendedEdit.vue"
          ),
      },
      {
        path: "/recommendedAdd", //後臺管理->推薦模塊
        name: "recommendedAdd",
        component: () =>
          import(
            "../views/setting/recommended/recommendedAdd/recommendedAdd.vue"
          ),
      },
      {
        path: "/customFees", //後臺管理->追加费用
        name: "customFees",
        component: () => import("../views/setting/customFees/customFees.vue"),
      },
      // --------------------------客服專區-----------------------------------
      {
        path: "/signedtochange", //客服專區->已入庫/已出庫/未簽收
        name: "signedtochange",
        component: () =>
          import("../views/customerservices/signedtochange/signedtochange.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/signOrderManage", //客服專區->已簽收
        name: "signOrderManage",
        component: () =>
          import(
            "../views/customerservices/signOrderManage/signOrderManage.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/feedback", //客服專區->問題反饋
        name: "feedback",
        component: () =>
          import("../views/customerservices/feedback/feedback.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/feedbackedit", //客服專區->問題反饋->回覆
        name: "feedbackedit",
        component: () =>
          import("../views/customerservices/feedbackedit/feedbackedit.vue"),
      },
      {
        path: "/customerRegister", //客服專區->新增會員
        name: "customerRegister",
        component: () =>
          import(
            "../views/customerservices/customerRegister/customerRegister.vue"
          ),
      },
      {
        path: "/allgoodsigntodo", //客服專區->全部快件
        name: "allgoodsigntodo",
        component: () =>
          import(
            "../views/customerservices/allgoodsigntodo/allgoodsigntodo.vue"
          ),
      },
      {
        path: "/allgoodrecycle", //客服專區->回收站
        name: "allgoodrecycle",
        component: () =>
          import("../views/customerservices/allgoodrecycle/allgoodrecycle.vue"),
      },
      {
        path: "/jifenoo", //客服專區->积分为0
        name: "jifenoo",
        component: () =>
          import("../views/customerservices/jifenoo/jifenoo.vue"),
      },
      {
        path: "/integralrecord", //客服專區->APP充值記錄
        name: "integralrecord",
        component: () =>
          import("../views/customerservices/integralrecord/integralrecord.vue"),
      },
      {
        path: "/packageFo", //客服專區-> 包裹預報
        name: "packageFo",
        component: () =>
          import("../views/customerservices/packageFo/packageFo.vue"),
      },
      {
        path: "/expressInterception", //客服專區-> 包裹拦截
        name: "expressInterception",
        component: () =>
          import(
            "../views/customerservices/expressInterception/expressInterception.vue"
          ),
      },
      {
        path: "/importExcel", //客服專區-> excel入库
        name: "importExcel",
        component: () =>
          import("../views/customerservices/importExcel/importExcel.vue"),
      },
      // {
      //   path: '/claimConfirmation', //客服專區-> 认领件确认
      //   name: 'claimConfirmation',
      //   component: () =>
      //       import('../views/customerservices/claimConfirmation/claimConfirmation.vue'),
      // },

      // ----------------------------送貨上門----------------------------
      // {
      //     path: '/DeliverPending', //送貨上門->待配送訂單
      //     name: 'deliverPending',
      //     component: () => import('../views/deliver/deliverPending/DeliverPending.vue')
      // },
      // {
      //     path: '/deliverTransit', //送貨上門->配送中訂單
      //     name: 'deliverTransit',
      //     component: () => import('../views/deliver/deliverTransit/deliverTransit.vue')
      // },
      // {
      //     path: '/deliverShipped', //送貨上門->已配送訂單
      //     name: 'deliverShipped',
      //     component: () => import('../views/deliver/deliverShipped/DeliverShipped.vue')
      // },
      {
        path: "/setDelivery", //送貨上門->設置送貨上門
        name: "setDelivery",
        component: () => import("../views/deliver/setDelivery/setDelivery.vue"),
      },
      {
        path: "/deliverSigntodo", //送貨上門-未簽收
        name: "deliverSigntodo",
        component: () =>
          // import('../views/deliver/deliverSigntodo/deliverSigntodo.vue'),
          import("../views/deliver/deliverSigntodo/deliverSigntodo2.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/deliverSigned", //送貨上門-已簽收
        name: "deliverSigned",
        component: () =>
          import("../views/deliver/deliverSigned/deliverSigned.vue"),
        meta: {
          keepAlive: true,
        },
      },
      // ----------------------------集金幣管理----------------------------
      {
        path: "/jpointRecommend", //集金幣管理->推薦
        name: "jpointRecommend",
        component: () =>
          import("../views/jpoint/jpointRecommend/jpointRecommend.vue"),
      },
      {
        path: "/jpointSetting", //集金幣管理->設置
        name: "jpointSetting",
        component: () =>
          import("../views/jpoint/jpointSetting/jpointSetting.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/jpointSettingAdd", //集金幣管理->設置->增加
        name: "jpointSettingAdd",
        component: () =>
          import("../views/jpoint/jpointSettingAdd/jpointSettingAdd.vue"),
      },
      {
        path: "/jpointSettingEdit", //集金幣管理->設置->修改
        name: "jpointSettingEdit",
        component: () =>
          import("../views/jpoint/jpointSettingEdit/jpointSettingEdit.vue"),
      },
      {
        path: "/jpointLog", //集金幣管理->日誌
        name: "jpointLog",
        component: () => import("../views/jpoint/jpointLog/jpointLog.vue"),
      },
      // ----------------------------同城配送----------------------------
      {
        path: "/samecityMasterlist", //同城配送->公司列表
        name: "samecityMasterlist",
        component: () =>
          import("../views/samecity/samecityMasterlist/samecityMasterlist.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/samecityMasterlistAdd", //同城配送->公司列表->增加
        name: "samecityMasterlistAdd",
        component: () =>
          import(
            "../views/samecity/samecityMasterlistAdd/samecityMasterlistAdd.vue"
          ),
      },
      {
        path: "/samecityMasterlistEdit", //同城配送->公司列表->修改
        name: "samecityMasterlistEdit",
        component: () =>
          import(
            "../views/samecity/samecityMasterlistEdit/samecityMasterlistEdit.vue"
          ),
      },
      {
        path: "/samecityChildlist", //同城配送->同城用戶列表(子號)
        name: "samecityChildlist",
        component: () =>
          import("../views/samecity/samecityChildlist/samecityChildlist.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/samecityChildlistAdd", //同城配送->同城用戶列表(子號)->增加
        name: "samecityChildlistAdd",
        component: () =>
          import(
            "../views/samecity/samecityChildlistAdd/samecityChildlistAdd.vue"
          ),
      },
      {
        path: "/samecityChildlistEdit", //同城配送->同城用戶列表(子號)->修改
        name: "samecityChildlistEdit",
        component: () =>
          import(
            "../views/samecity/samecityChildlistEdit/samecityChildlistEdit.vue"
          ),
      },
      {
        path: "/samecityMultiScanin", //同城配送->多件導入Excel
        name: "samecityMultiScanin",
        component: () =>
          import(
            "../views/samecity/samecityMultiScanin/samecityMultiScanin.vue"
          ),
      },
      {
        path: "/samecityMultiScaninEdit", //同城配送->多件導入Excel->修改
        name: "samecityMultiScaninEdit",
        component: () =>
          import(
            "../views/samecity/samecityMultiScaninEdit/samecityMultiScaninEdit.vue"
          ),
      },
      {
        path: "/samecityScanin", //同城配送->同城入庫
        name: "samecityScanin",
        component: () =>
          import("../views/samecity/samecityScanin/samecityScanin.vue"),
      },
      {
        path: "/samecityScaninEdit", //同城配送->同城入庫->修改
        name: "samecityScaninEdit",
        component: () =>
          import("../views/samecity/samecityScaninEdit/samecityScaninEdit.vue"),
      },
      {
        path: "/samecityList", //同城配送->本地交收記錄->全部
        name: "samecityList",
        // component: () => import('../views/samecity/samecityList/samecityList.vue'),
        component: () =>
          import("../views/samecity/samecityList/samecityList_new.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/samecityListToDo", //同城配送->本地交收記錄->待交收
        name: "samecityListToDo",
        component: () =>
          import("../views/samecity/samecityListToDo/samecityListToDo.vue"),
        // meta: {
        //     keepAlive: true
        // }
      },
      {
        path: "/samecityListShop", //同城配送->本地交收記錄->到店/櫃
        name: "samecityListShop",
        component: () =>
          import("../views/samecity/samecityListShop/samecityListShop.vue"),
        // meta: {
        //     keepAlive: true
        // }
      },
      {
        path: "/samecityListSigned", //同城配送->本地交收記錄->已簽收
        name: "samecityListSigned",
        component: () =>
          import("../views/samecity/samecityListSigned/samecityListSigned.vue"),
        // meta: {
        //     keepAlive: true
        // }
      },
      // ----------------------------活動----------------------------
      {
        path: "/eventList", //活動->活動列表
        name: "eventList",
        component: () => import("../views/event/eventList/eventList.vue"),
      },
      {
        path: "/eventListEdit", //活動->活動列表->修改
        name: "eventListEdit",
        component: () =>
          import("../views/event/eventListEdit/eventListEdit.vue"),
      },
      {
        path: "/eventListAdd", //活動->活動列表->新增
        name: "eventListAdd",
        component: () => import("../views/event/eventListAdd/eventListAdd.vue"),
      },
      {
        path: "/LotteryLog", //活動->積分支付抽獎日誌
        name: "LotteryLog",
        component: () => import("../views/event/LotteryLog/LotteryLog.vue"),
      },
      {
        path: "/eventLog", //活動->活動詳情
        name: "eventLog",
        component: () => import("../views/event/eventLog/eventLog.vue"),
      },
      // ----------------------------加盟----------------------------
      {
        path: "/franchiseList", //加盟->列表
        name: "franchiseList",
        component: () =>
          import("../views/franchise/franchiseList/franchiseList.vue"),
      },
      // ----------------------------派送專線----------------------------
      {
        path: "/deliveryareaTodo", //派送專線->待派送訂單
        name: "deliveryareaTodo",
        // component: () => import('../views/deliveryarea/deliveryareaTodo/deliveryareaTodo.vue'),
        component: () =>
          import(
            "../views/deliveryarea/deliveryareaTodo/deliveryareaTodo_new.vue"
          ),
      },
      {
        path: "/deliveryareaIng", //派送專線->派送中訂單
        name: "deliveryareaIng",
        // component: () => import('../views/deliveryarea/deliveryareaIng/deliveryareaIng.vue'),
        component: () =>
          import(
            "../views/deliveryarea/deliveryareaIng/deliveryareaIng_new.vue"
          ),
      },
      {
        path: "/deliveryareaDone", //派送專線->已派送訂單
        name: "deliveryareaDone",
        // component: () => import('../views/deliveryarea/deliveryareaDone/deliveryareaDone.vue'),
        component: () =>
          import(
            "../views/deliveryarea/deliveryareaDone/deliveryareaDone_new.vue"
          ),
      },
      {
        path: "/deliveryareaSetting", //派送專線->派送設定
        name: "deliveryareaSetting",
        // component: () => import('../views/deliveryarea/deliveryareaSetting/deliveryareaSetting.vue'),
        component: () =>
          import(
            "../views/deliveryarea/deliveryareaSetting/deliveryareaSetting_new.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/deliveryareatimeSetting", //派送專線->派送時間設定
        name: "deliveryareatimeSetting",
        // component: () => import('../views/deliveryarea/deliveryareatimeSetting/deliveryareatimeSetting.vue'),
        component: () =>
          import(
            "../views/deliveryarea/deliveryareatimeSetting/deliveryareatimeSetting_new.vue"
          ),
      },
      {
        path: "/deliveryareaaddressSetting", //派送專線->派送地址設定
        name: "deliveryareaaddressSetting",
        // component: () => import('../views/deliveryarea/deliveryareaaddressSetting/deliveryareaaddressSetting.vue'),
        component: () =>
          import(
            "../views/deliveryarea/deliveryareaaddressSetting/deliveryareaaddressSetting_new.vue"
          ),

        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/deliveryareabuildingtimeSetting", //派送專線->派送大廈時間設定
        name: "deliveryareabuildingtimeSetting",
        // component: () => import('../views/deliveryarea/deliveryareabuildingtimeSetting/deliveryareabuildingtimeSetting.vue'),
        component: () =>
          import(
            "../views/deliveryarea/deliveryareabuildingtimeSetting/deliveryareabuildingtimeSetting_new.vue"
          ),
      },
      {
        path: "/deliveryareanotdutySetting", //派送專線->不派送日期選擇設定
        name: "deliveryareanotdutySetting",
        component: () =>
          import(
            "../views/deliveryarea/deliveryareanotdutySetting/deliveryareanotdutySetting.vue"
          ),
      },
      {
        path: "/deliveryareaLimit", //派送專線-> 长宽高限制
        name: "deliveryareaLimit",
        component: () =>
          import(
            "../views/deliveryarea/deliveryareaLimit/deliveryareaLimit.vue"
          ),
      },
      // ----------------------------快遞記錄---珠海倉-------------------------
      {
        path: "/zhuhaiInventory", //快遞記錄->珠海倉記錄
        name: "zhuhaiInventory",
        component: () =>
          import("../views/faststock/zhuhaiInventory/zhuhaiInventory.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/zhuhaiInventoryGrid", //快遞記錄->珠海倉記錄->自提點件數
        name: "zhuhaiInventoryGrid",
        component: () =>
          import(
            "../views/faststock/zhuhaiInventoryGrid/zhuhaiInventoryGrid.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/zhuhaiInventoryRecord", //快遞記錄->珠海倉記錄->差異記錄
        name: "zhuhaiInventoryRecord",
        component: () =>
          import(
            "../views/faststock/zhuhaiInventoryRecord/zhuhaiInventoryRecord.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/zhuhaiInventoryRecordDetail", //快遞記錄->珠海倉記錄->差異記錄->修改
        name: "zhuhaiInventoryRecordDetail",
        component: () =>
          import(
            "../views/faststock/zhuhaiInventoryRecordDetail/zhuhaiInventoryRecordDetail.vue"
          ),
      },

      // ----------------------------快遞記錄---澳門倉-------------------------

      {
        path: "/macaoInventory", //快遞記錄->澳門倉記錄
        name: "macaoInventory",
        component: () =>
          import("../views/faststock/macaoInventory/macaoInventory.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/macaoInventoryGrid", //快遞記錄->澳門倉記錄->自提點件數
        name: "macaoInventoryGrid",
        component: () =>
          import(
            "../views/faststock/macaoInventoryGrid/macaoInventoryGrid.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/macaoInventoryRecord", //快遞記錄->澳門倉記錄->差異記錄
        name: "macaoInventoryRecord",
        component: () =>
          import(
            "../views/faststock/macaoInventoryRecord/macaoInventoryRecord.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/macaoInventoryRecordDetail", //快遞記錄->澳門倉記錄->差異記錄->修改
        name: "macaoInventoryRecordDetail",
        component: () =>
          import(
            "../views/faststock/macaoInventoryRecordDetail/macaoInventoryRecordDetail.vue"
          ),
      },

      // ----------------------------快遞記錄---澳門門店-------------------------

      {
        path: "/shopInventory", //快遞記錄->門店記錄
        name: "shopInventory",
        component: () =>
          import("../views/faststock/shopInventory/shopInventory.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/shopInventoryGrid", //快遞記錄->門店記錄->自提點件數
        name: "shopInventoryGrid",
        component: () =>
          import("../views/faststock/shopInventoryGrid/shopInventoryGrid.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/shopInventoryRecord", //快遞記錄->門店記錄->差異記錄
        name: "shopInventoryRecord",
        component: () =>
          import(
            "../views/faststock/shopInventoryRecord/shopInventoryRecord.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/shopInventoryRecordDetail", //快遞記錄->門店記錄->差異記錄->修改
        name: "shopInventoryRecordDetail",
        component: () =>
          import(
            "../views/faststock/shopInventoryRecordDetail/shopInventoryRecordDetail.vue"
          ),
      },
      // ----------------------------商品-----------------------------
      {
        path: "/commodityList", //商品->商品列表
        name: "commodityList",
        component: () =>
          import("../views/commodity/commodityList/commodityList.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/couponRedemptionList", //商品->优惠卷兑换列表
        name: "couponRedemptionList",
        component: () =>
          import(
            "../views/commodity/couponRedemptionList/couponRedemptionList.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/commodityAdd", //商品->添加商品
        name: "commodityAdd",
        component: () =>
          import("../views/commodity/commodityAdd/commodityAdd.vue"),
        // import('../views/commodity/commodityAdd/commodityAdd2.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/commodityEdit", //商品->修改商品
        name: "commodityEdit",
        component: () =>
          import("../views/commodity/commodityEdit/commodityEdit.vue"),
        // import('../views/commodity/commodityEdit/commodityEdit2.vue'),
        // meta: {
        //     keepAlive: true
        // }
      },
      {
        path: "/commodityTypes", //商品->商品類型
        name: "commodityTypes",
        component: () =>
          import("../views/commodity/commodityTypes/commodityTypes.vue"),
        // meta: {
        //     keepAlive: true
        // }
      },
      {
        path: "/commoDiscounts", //商品->优惠卷商家
        name: "commoDiscounts",
        component: () =>
          import("../views/commodity/commodityTypes/commoDiscounts.vue"),
        // meta: {
        //     keepAlive: true
        // }
      },
      {
        path: "/appbanneradvertiserManage", //後臺管理->商品區域設置
        name: "appbanneradvertiserManage",
        component: () =>
          import(
            "../views/commodity/appbanneradvertiserManage/appbanneradvertiserManage.vue"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/appbanneradvertiserManageAdd", //後臺管理->商品區域設置->增加
        name: "appbanneradvertiserManageAdd",
        component: () =>
          import(
            "../views/commodity/appbanneradvertiserManageAdd/appbanneradvertiserManageAdd.vue"
          ),
      },
      {
        path: "/appbanneradvertiserManageEdit", //後臺管理->商品區域設置->修改
        name: "appbanneradvertiserManageEdit",
        component: () =>
          import(
            "../views/commodity/appbanneradvertiserManageEdit/appbanneradvertiserManageEdit.vue"
          ),
      },
      // ----------------------------訂單-----------------------------
      {
        path: "/orderList", //訂單->訂單列表
        name: "orderList",
        component: () => import("../views/order/orderList/orderList.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/orderdetailedList", //訂單->訂單列表->訂單詳情
        name: "orderdetailedList",
        component: () =>
          import("../views/order/orderdetailedList/orderdetailedList.vue"),
        // meta: {
        //     keepAlive: true
        // }
      },
      // ----------------------------BTB-----------------------------
      {
        path: "/btbList", //訂單->訂單列表
        name: "btbList",
        component: () => import("../views/BTB/btbList/btbList.vue"),
        meta: {
          keepAlive: false,
        },
      },
      {
        path: "/claimConfirmation", //客服專區-> 认领件确认
        name: "claimConfirmation",
        component: () =>
          import(
            "../views/customerservices/claimConfirmation/claimConfirmation.vue"
          ),
      },
    ],
  },
  {
    path: "/login", // 登入頁面
    name: "login",
    component: () => import("../views/login/Login.vue"),
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to, form);
  if (to.path == "/login") {
    next();
  } else {
    let userInfo = localStorage.getItem("jyb_token");
    if (userInfo) {
      next();
    } else {
      next("/login");
    }
  }
});

export default router;
